var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConvenientTarrifs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 80,
    fill: "currentColor",
    viewBox: "0 0 70 80",
    stroke: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.554 78.533c19.083 0 34.554-8.523 34.554-19.038 0-10.514-15.47-19.038-34.554-19.038C15.47 40.457 0 48.981 0 59.495 0 70.01 15.47 78.533 34.554 78.533Z",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.116 69.607-3.377-3.156a2.89 2.89 0 0 1-.922-2.128l.264-51.52c.01-1.568 1.106-2.927 2.665-3.297l35.615-8.459a3.043 3.043 0 0 1 2.65.619l2.68 2.687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m17.116 69.607-3.377-3.156a2.89 2.89 0 0 1-.922-2.128l.264-51.52c.01-1.568 1.106-2.927 2.665-3.297l35.615-8.459a3.043 3.043 0 0 1 2.65.619l2.68 2.687"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeMiterlimit: 10,
    d: "m16.363 68.082-.05-52.367c0-1.554 1.071-2.912 2.61-3.302l35.765-9.087c1.26-.321 2.495.609 2.495 1.885v52.08c0 1.544-1.06 2.893-2.58 3.292l-35.724 9.38c-1.27.33-2.516-.6-2.516-1.88Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m19.995 24.363-.05-5.06c-.01-1.124.767-2.113 1.888-2.386l30.345-7.411c.622-.151 1.23.302 1.235.93l.075 5.001a2.442 2.442 0 0 1-1.883 2.396l-30.37 7.465c-.627.156-1.235-.307-1.24-.935Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M50.655 15.774c.237-.518.123-1.071-.254-1.236-.377-.164-.874.123-1.11.641-.237.518-.123 1.071.254 1.236.377.164.874-.123 1.11-.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M50.655 15.774c.237-.518.123-1.071-.254-1.236-.377-.164-.874.123-1.11.641-.237.518-.123 1.071.254 1.236.377.164.874-.123 1.11-.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M50.655 15.774c.237-.518.123-1.071-.254-1.236-.377-.164-.874.123-1.11.641-.237.518-.123 1.071.254 1.236.377.164.874-.123 1.11-.64ZM47.62 13.5c.237-.518.123-1.071-.253-1.235-.377-.165-.874.122-1.11.64-.237.519-.123 1.072.253 1.236.377.165.874-.122 1.11-.64Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "m46.94 17.005 3.039-5.357"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.27 30.884.04-6.034 5.903-1.436v5.984l-5.943 1.486Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.269 30.884-.732-.658.04-5.95 5.972-1.442.662.58"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.27 24.393h-.464v.418h.463v-.418Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.68 32.929.04-6.034 5.907-1.436v5.985l-5.947 1.485Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.678 32.929-.732-.657.045-5.951 5.967-1.437.668.575"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.679 26.438h-.463v.419h.463v-.419Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.334 34.906.04-6.033 5.907-1.437v5.985l-5.947 1.485Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.332 34.906-.732-.657.045-5.95 5.967-1.442.668.58"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 28.415h-.463v.42h.463v-.42Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.968 36.95.04-6.033 5.902-1.436v5.985l-5.942 1.485Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.966 36.951-.732-.652.045-5.956 5.967-1.436.663.574"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.967 30.46h-.464v.419h.464v-.419Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.31 39.294.04-6.034 5.903-1.436v5.984l-5.943 1.486Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.309 39.294-.733-.658.045-5.95 5.968-1.437.662.575"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.31 32.802h-.463v.419h.463v-.419Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.718 41.339.04-6.034 5.902-1.431v5.984l-5.942 1.48Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.716 41.339-.732-.653.045-5.956 5.967-1.436.663.58"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.718 34.848h-.464v.419h.464v-.42Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.37 43.316.04-6.034 5.903-1.436v5.985l-5.942 1.485Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.371 43.316-.732-.658.045-5.95 5.967-1.437.663.575"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.37 36.825h-.463v.418h.463v-.418Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m22.008 45.36.04-6.028 5.902-1.437v5.985l-5.942 1.48Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m22.007 45.361-.737-.652.045-5.951 5.967-1.442.668.58"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.01 38.874h-.464v.42h.463v-.42Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.27 48.059.04-6.033 5.903-1.437v5.985l-5.943 1.485Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.269 48.059-.732-.658.04-5.95 5.972-1.437.662.575"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.27 41.568h-.464v.418h.463v-.418Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.68 50.104.04-6.034 5.907-1.431v5.984l-5.947 1.48Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.678 50.104-.732-.653.045-5.955 5.967-1.437.668.58"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.679 43.613h-.463v.419h.463v-.42Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.334 52.08.04-6.033 5.907-1.436v5.985l-5.947 1.485Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.332 52.08-.732-.657.045-5.95 5.967-1.437.668.575"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 45.59h-.463v.419h.463v-.42Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.968 54.126.04-6.029 5.902-1.436v5.984l-5.942 1.48Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.966 54.126-.732-.652.045-5.951 5.967-1.442.663.58"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.967 47.64h-.464v.419h.464v-.42Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.19 56.469.04-6.034 5.908-1.437v5.985l-5.947 1.486Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m47.19 56.468-.732-.657.045-5.95 5.967-1.437.668.575"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M47.19 49.977h-.463v.42h.463v-.42Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.604 58.518.04-6.033 5.903-1.437v5.985l-5.943 1.485Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m38.604 58.519-.732-.658.044-5.95 5.968-1.442.662.58"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M38.604 52.028h-.463v.419h.463v-.42Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.255 60.491.04-6.033 5.903-1.437v5.985l-5.943 1.485Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m30.254 60.49-.732-.657.045-5.95 5.967-1.437.662.575"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.255 54h-.463v.418h.463V54Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.89 62.54.04-6.033 5.902-1.436v5.985L21.89 62.54Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m21.89 62.54-.732-.657.04-5.95 5.968-1.442.667.58"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.89 56.05h-.464v.419h.464v-.42Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConvenientTarrifs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/convenient-tarrifs.3f0bf3d13be0dd3bc042d61e4c04538e.svg";